export default __webpack_public_path__ + "static/media/hht1_ep11_minisitcom_02.adc28074.png";